import { Injectable } from '@angular/core';
import { AppState } from '../appstate';
import { Store } from '@ngrx/store';
import {
  CurrentUser,
  SessionInfo,
  SessionState,
} from '../../data/authentication-info';
import { Observable } from 'rxjs';
import { ServerInfo } from '../../data/server-info';
import { BehaviorSubject } from 'rxjs';
/**
 * Created by ashok on 10/05/17.
 */

@Injectable()
export class SessionDataService {
  public getSessionStatusObs = new BehaviorSubject<any>({});
  constructor(private store: Store<AppState>) { }

  /**
   * Gets the session info object
   * @returns {Promise<T>}
   */
  public getSession(): Observable<SessionInfo> {
    return this.store.select((appState: any) => {
      //

      return appState.reducers.sessionInfo
    });

  }

  public getSessionStatus(): Observable<SessionState> {
    return this.store.select((appState: any) => {
      //

      this.getSessionStatusObs.next(appState.reducers.sessionInfo.status);
      return appState.reducers.sessionInfo.status;
    });
  }

  /**
   * Specifies whether to show login form or not
   * @returns {Promise<T>}
   */
  public showLoginForm(): Observable<boolean> {

    return this.store.select((appState: any) => {
      //
      return appState.reducers.sessionInfo.loginForm;

    });
  }
  /**
   * Gets the current user
   * @returns {Promise<T>}
   */
  public getCurrentUser(): Observable<CurrentUser> {
    return this.store.select((appState: any) => {
      return {
        userName: appState.reducers.sessionInfo.userName,
        password: appState.reducers.sessionInfo.password,
      };
    });
  }

  public getAuthToken(): Observable<string> {
    return this.store.select(
      (appState: any) => appState.reducers.sessionInfo.authToken
    );
  }

  public getCurrentSession(): Observable<SessionInfo> {
    return this.store.select((appState: any) => {
      return appState.reducers.sessionInfo;
    });
  }

  public getServerInfo(): Observable<ServerInfo> {
    return this.store.select((appState: any) => {

      this.getSessionStatusObs.next(appState.reducers);
      return appState.reducers.serverInfo;
    });
  }
  public getNeedRefresh(): Observable<boolean> {
    return this.store.select((appState: any) => {
      console.debug("get need refresh ", appState)
      return appState.reducers.sessionInfo.needRefresh
    });
  }
}
